module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-19-1a0c607cd36527e2fa99b718794403f2.png";